import classNames from 'classnames'
import styles from './top-aligned-layout.module.scss'

interface TopAlignedLayoutProps {
  className?: string
  children?: React.ReactNode
}

export default function TopAlignedLayout({ className, children }: TopAlignedLayoutProps) {
  return <div className={classNames(className, styles.root)}>{children}</div>
}
